export default __webpack_public_path__ + "static/media/CreatePL.715fe79b.png";